import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  anchor: {
    alignSelf: 'stretch',
    height: 0,
    position: 'relative',
    zIndex: 1000,
  },
  card: {
    alignItems: 'flex-start',
    backgroundColor: Theme.palette.white,
    border: '1px solid #00A0CC',
    borderRadius: 4,
    boxShadow: '0 2px 8px rgba(6, 21, 86, 0.15)',
    boxSizing: 'border-box',
    display: 'flex',
    gap: 16,
    maxWidth: 608,
    padding: '20px 20px 20px 28px',
    position: 'absolute',
    right: 24,
    top: 24,
    width: 'calc(100% - 48px)',
    [Theme.breakpoints.down('sm')]: {
      left: 16,
      maxWidth: 'none',
      padding: '16px',
      right: 16,
      top: 16,
      width: 'auto',
    },
  },
  icon: {
    color: '#00A0CC',
    flexShrink: 0,
    marginTop: 1,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    color: '#1B1B1B',
    fontFamily: Theme.typography.base.semiBold,
    fontSize: 16,
    lineHeight: '24px',
    margin: '0 0 4px',
  },
  description: {
    color: '#315788',
    fontFamily: Theme.typography.base.regular,
    fontSize: 15,
    lineHeight: '25px',
    margin: 0,
  },
  bold: {
    fontFamily: Theme.typography.base.semiBold,
    fontWeight: 400,
  },
  close: {
    background: 'none',
    border: 0,
    color: '#021D49',
    cursor: 'pointer',
    flexShrink: 0,
    height: 24,
    lineHeight: 0,
    margin: 0,
    padding: 0,
    width: 24,
    '&:focus-visible': {
      outline: '2px solid #00A0CC',
      outlineOffset: 2,
    },
  },
}));

export default useStyles;
